// Chain IDs
export const chainIDs =
  process.env.NEXT_PUBLIC_CHAIN_IDS?.split(',').map((n) => Number(n)) || []

export const platformLVTFee = 250 // Expressed in bps (250bps === 2.5%)
export const platformFee = 25 // Expressed in bps (25bps === 0.25%)
